import React from "react";
// import LoginPage from "./component/login/login";
import RegisterPage from "./component/login/RegisterPage";
import Dashboard from "./component/dashboard/Dashboard";
import CallPage from "./component/dashboard/CallPage";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "./component/PrivateRoute";
import LoginPage from "./component/login/LoginPage";
import GetStarted from "./component/login/GetStarted";
import BusinessName from "./component/login/BusinessName";
import UrlPage from "./component/login/urlPage";
import CallsPage from "./component/login/CallsPage";
import AiAgentPage from "./component/login/AiAgentPage";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ExecutiveDashboard from "./component/ExecutiveDashboard/ExecutiveDashboard";
import AdminDashboard from "./component/AdminDashboard/AdminDashboard";
import RecordingDashboard from "./component/RecordingList/RecordingDashboard";
import CallFlow from "./component/dashboard/CallFlow";

const App = () => {
  return (
    <div className=" bg-gray-50">
      <Router>
        <Routes>
          <Route path="/" element={<LoginPage></LoginPage>} />
          <Route path="/admin/reg" element={<RegisterPage />} />

          <Route path="/get-started" element={<GetStarted />} /> {/* Added route for GetStarted */}

          <Route path="/business-name" element={<BusinessName />} />

          <Route path="/url-page" element={<UrlPage />} />

          <Route path="/calls-page" element={<CallsPage />} />

          <Route path="/ai-agent-page" element={<AiAgentPage />} />

         
          <Route path="/executive-dashboard" element={<PrivateRoute allowedRoles={["executive"]}> <ExecutiveDashboard></ExecutiveDashboard></PrivateRoute>} />

          <Route path="/recordingdashboard" element={<PrivateRoute allowedRoles={["qa"]}> <RecordingDashboard></RecordingDashboard></PrivateRoute>} />

          <Route path="/admin-dashboard" element={<PrivateRoute allowedRoles={["admin"]}  ><AdminDashboard></AdminDashboard> </PrivateRoute>} />

          <Route path="/dashboard" element={<PrivateRoute allowedRoles={["user"]}  > <Dashboard /></PrivateRoute>} />
          <Route
            path="/call/:name/:number"
            element={<CallPage />}
          />

<Route path="/CallFlow" element={<CallFlow ></CallFlow>} />


          {/* <Route path="Ryngmosrecording" element={<Ryngmosftpbucket></Ryngmosftpbucket>} /> */}

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>


      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default App;